const config = {
  url: '/tutorial-type/:id',
  getTitle: id => id === 'create' ? 'Создание типа учебного пособия' : 'Редактирование типа учебного пособия',
  getApiUrl: id => id === 'create' ? '/tutorial-types' : `/tutorial-types/${id}`,
  type: 'card',
  access: ['*'],
  tabs: [
    {
      key: 'common',
      title: 'Общее',
      children: {
        left: [
          {
            key: 'name',
            title: 'Название',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: true,
          },
        ],
        right: [
          {
            key: 'name_en',
            title: 'Название (en)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
          },
        ],
        both: [],
      }
    }
  ]
}

export default config
